import VALIDATION_MESSAGES from "helpers/validation/messages";
import Validators from "helpers/validation/validators";
import type { IErrors, INewCreditCardAdyen } from "types/reducers/payment";

const cardholderInfoValidators = {
  address1: Validators.isNotEmpty,
  city: Validators.isNotEmpty,
  firstName: Validators.isNotEmpty,
  lastName: Validators.isNotEmpty,
  state: Validators.isNotEmpty,
  zip: Validators.isValidZipCode,
};

export function validateAdyenCardDetails(
  card: INewCreditCardAdyen,
  validators = cardholderInfoValidators
): IErrors | null {
  const errorEntries: Array<[string, string]> = [];

  const fieldNamesWithError: string[] = [];
  if (!Validators.isValid(card, validators, fieldNamesWithError)) {
    errorEntries.push(
      ...fieldNamesWithError.map(
        fieldName =>
          <[string, string]>[fieldName, VALIDATION_MESSAGES[fieldName]]
      )
    );
  }

  const adyenFormState = card.ccData;
  if (!adyenFormState.isValid) {
    const { valid, errors } = adyenFormState;

    // Adyen does its own validation but it does not provide an error message when the value is empty.
    // Hence we need to manually add the empty error message.
    if (!valid.encryptedCardNumber) {
      errorEntries.push([
        "encryptedCardNumber",
        errors.encryptedCardNumber?.errorI18n ?? VALIDATION_MESSAGES.cardNumber,
      ]);
    }

    if (!valid.encryptedExpiryYear || !valid.encryptedExpiryMonth) {
      errorEntries.push([
        "encryptedExpiryDate",
        errors.encryptedExpiryDate?.errorI18n ?? VALIDATION_MESSAGES.expiryDate,
      ]);
    }
    if (!valid.encryptedSecurityCode) {
      errorEntries.push([
        "encryptedSecurityCode",
        errors.encryptedSecurityCode?.errorI18n ?? VALIDATION_MESSAGES.cvv,
      ]);
    }
  }

  if (errorEntries.length) {
    return Object.fromEntries(errorEntries);
  }

  return null;
}
